module.exports = __webpack_public_path__ + "media/images/has-comments-icon-a1abe2a052ff398a03498b252ac55f34.png";